<!-- This code has been fully generated by an AI. -->
<div class="join w-full">
  <label
    class="btn btn-sm join-item flex-1 tooltip tooltip-left focus-within:outline-2 focus-within:outline-primary focus-within:outline-offset-2"
    data-tip="JPEG/PNG bis 5 MiB. Wird auf maximal 240 x 240 Pixel verkleinert."
    [class.btn-disabled]="pictureBusy() || !employeeDataService.employee()"
  >
    <input
      #pictureInput
      type="file"
      accept="image/jpeg,image/png"
      class="sr-only"
      (change)="uploadPicture(pictureInput)"
      [disabled]="pictureBusy() || !employeeDataService.employee()"
    />
    @if (pictureBusy()) {
      <span class="loading loading-spinner loading-xs" aria-hidden="true"></span>
    }
    {{ employeeDataService.hasLocalPicture() ? 'Profilbild ersetzen' : 'Profilbild hochladen' }}
  </label>
  @if (employeeDataService.hasLocalPicture()) {
    <button
      type="button"
      class="btn btn-sm btn-error btn-square join-item tooltip tooltip-top"
      aria-label="Profilbild löschen"
      data-tip="Profilbild löschen"
      [disabled]="pictureBusy()"
      (click)="deletePicture()"
    >
      <ng-icon name="heroTrash" strokeWidth="2" size="20" />
    </button>
  }
</div>
